var ctrl = function(GoogleTranslate) {
  GoogleTranslate.load().then(function(d) {
    if ((typeof google !== 'undefined') && _.get(google, 'translate.TranslateElement.InlineLayout')) {
      new google.translate.TranslateElement({pageLanguage: "en", layout: google.translate.TranslateElement.InlineLayout.HORIZONTAL, gaTrack: true, gaId:"UA-98515154-1"}, "google_translate_element");
    }  
  });  
};

ctrl.$inject = ['GoogleTranslate'];

tiz.controller('tizGoogleTranslateCtrl', ctrl);

tiz.directive("tizGoogleTranslate", function() {
  return {
    scope: {},
    restrict: 'E',
    template:'<div id="google_translate_element"></div>',
    controller: 'tizGoogleTranslateCtrl'
  };
});
